<template>
  <div class="page-content">
    <div class="administrador-heading">
      <h5>{{ $t("lang.admin.printer_form.page_title") }}</h5>
    </div>
    <div class="centros-formbg">
      <h6>{{ $t("lang.admin.printer_form.add_form_title") }}</h6>
      <div class="centros-form">
        <div v-if="errors.length && !success.show">
          <b>{{ $t("lang.admin.printer_form.error_list_title") }}</b>
          <div class="alert alert-danger" role="alert">
            <ul style="list-style-type: circle;margin: 10px">
              <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
            </ul>
          </div>
        </div>
        <div v-show="success.show">
          <div class="alert alert-success" role="alert">
            {{ success.message }}
          </div>
        </div>

        <form>
          <div class="form-row">
            <div class="select-box col-md-6">
              <v-select
                :items="tags"
                item-text="tag_type.reference"
                item-value="tag_type.id"
                v-model="selectedTag"
                prefix="Tag Type :   "
              ></v-select>
            </div>
            <div class="col-md-6">
                <v-select
                  :items="tagFormats"
                  item-text="tag_format.description"
                  item-value="tag_format.id"
                  v-model="selectedTagFormat"
                  prefix="Tag Format :   "
                ></v-select>
            </div>
          </div>
          

        <v-card-text>
          <form>

            <div class="form-row" v-for="(item, index) in contentParams" :key="index">

          <v-progress-circular v-if="item.loading" indeterminate style="margin-top: 23px;" color="#9ac31c"></v-progress-circular>              
  
          <div class="select-box col-md-2" :disabled="gtins.length < 1">
                <v-combobox :items="gtins" :item-text="`gtin`" :item-value="`gtin`" v-model="item.gtin" :error="item.wrong" 
                  hide-details :hide-no-data="!searchGtinInput" :label="$t('lang.admin.purchase_order.gtin')" outlined
                  :menu-props="{closeOnClick: true, closeOnContentClick: true,}" :search-input.sync="searchGtinInput[index]">
                  <template v-slot:no-data>
                    <v-list-item @click="openAddGtinDialog" v-if="searchGtinInput[index]">
                      <span class="subheading">Create &nbsp;</span>
                      <v-chip label small>{{ searchGtinInput[index] }}</v-chip>
                    </v-list-item>
                  </template>
                </v-combobox>
              </div>


              <div class="select-box col-md-2">
              <v-text-field label="Expiration date" outlined hide-details v-model="item.fecha" :error="item.wrong"></v-text-field>
              </div>
              <div class="select-box col-md-2">
                <v-text-field label="Lot" outlined hide-details v-model="item.lote" :error="item.wrong"></v-text-field>
              </div>
              <div class="select-box col-md-1">
                <v-text-field :label="$t('lang.admin.purchase_order.qty')" outlined hide-details v-model="item.quantity" :error="item.wrong"></v-text-field>
              </div>
              <div class="select-box col-md-1">
                <v-icon x-large class="mt-2" @click="focusInput(index)">mdi-barcode-scan</v-icon>
              </div>
              <div class="select-box col-md-1" v-if="index === contentParams.length - 1">
                <v-icon x-large class="mt-2" @click="addNewContentRow">mdi-plus-circle-outline</v-icon>
              </div>
              <div class="select-box col-md-1" v-if="contentParams.length > 1">
                <v-icon x-large class="mt-2" @click="removeRow(index)">mdi-minus-circle-outline</v-icon>
              </div>
              <div class="select-box col-md-0">
              <input  @focus="item.loading = true" @blur="item.loading = false" class="select-box col-md-1" style="opacity: 0" :ref="'barcodeInput' + index" v-model="item.barcode" @keyup.enter="parse_gs1_128(index)">
               
              </div>
            </div>
          </form>
        </v-card-text>

          <div class="form-row">
            <div class="mb-0 col-md-12">
              <v-btn text rounded @click="$router.push({ name: 'PrintersList' })">{{ $t("lang.location_form.btn_cancel") }}</v-btn>
              <bx-btn type="submit" color="primary" @click="submitForm">{{ $t("lang.admin.printer_form.btn_done")}}</bx-btn>
            </div>
          </div>
        </form>
       <AddGTINDialog ref="addGtinDialogRef" @close="dialog = true" />
      </div>
    </div>
  </div>
</template>

<script>
import AddGTINDialog from "../../components/AddGTINDialog.vue";
import moment from "moment";

export default {
  name: "GeneratePrinterOrderManual",
  components: {
    AddGTINDialog,
  },
  data() {
    return {

      barcodeInputs: [""],
      gtin: "",
      tags: [],
      items:[],
      totalQuantity: 0,
      contentParams: [{ quantity: null, gtin: null, fecha:null, lote:null,barcode:null, loading:false, wrong:false }],
      gtins: [],
      searchGtinInput: [],
      tagFormats: [],
      selectedTagFormat: null,
      file: null,
      selectedPrinter: null,
      selectedTag: null,
      errors: [],
      success: {
        show: false,
        message: this.$t("lang.admin.printer_form.success_add_printer_order")
      },
      errorLabels: {
        failed: this.$t("lang.messages.label_something_went_wrong")
      }
    };
  },
  async mounted() {
    this.user = await this.$api.printer.printer_user(
      this.$store.state.user.user
    );
    this.tags = await this.$api.printer.printer_tagtype();
    this.tagFormats = await this.$api.printer.printer_tagtype({tag_type: this.selectedTag});
    
  },
  methods: {
    async focusInput(index) {
       this.barcode=""
       this.barcodeInputs[index]=""
       this.$refs['barcodeInput' + index][0].focus();
    },
    async addNewContentRow() {
      this.contentParams.push({ quantity: null, gtin: null, lote:null, fecha:null, loading:false, wrong:false });
      this.barcodeInputs.push("");
    },
    async removeRow(index) {
      this.contentParams.splice(index, 1);
    },
    openAddGtinDialog() {
      this.dialog = false;
      setTimeout(() => {
        this.$refs.addGtinDialogRef.open();
        this.searchGtinInput = [];
      }, 0);
    },
    async submitForm() {
      this.items=[]
      this.totalQuantity=0
        for (let i = 0; i < this.contentParams.length; i++) {
          try {
             await this.$api.types.getV1(this.contentParams[i].gtin);
             this.items.push({"gtin": this.contentParams[i].gtin, "expiration":moment(this.contentParams[i].fecha, 'YYMMDD').format('YYYY-MM-DD HH:mm:ss'),
              "lot":this.contentParams[i].lote, "theorical_quantity":this.contentParams[i].quantity});
              this.totalQuantity+=Number(this.contentParams[i].quantity);

          } catch (error) {
            console.log(error)
            this.contentParams[i].wrong=true
            return;
          }

          }
        this.companyFormat = await this.$api.printer.printer_tagtype({
          tag_type: this.selectedTag,
          tag_format: this.selectedTagFormat,
          limit: 10
        }); 
        const res = await this.$api.printer.set_print_order({
            companyformat_id: this.companyFormat.results[0].id,
            responsible_id: this.user.company,
            total_quantity: this.totalQuantity,
            items: this.items
        });
        console.log(res)
        // try {
        //   const res = await this.$api.printer.printUploadedFileNEW(
        //           this.companyFormat.results[0].id,
        //           this.user.company,
        //           this.file);
        // } catch (error) {
        //   this.errors.push(this.errorLabels.failed);
        //   console.error(error);
        // } finally {
        //   this.success.show = true;
        // }
    },
    async parse_gs1_128(index) {
    var barcode=this.contentParams[index].barcode
    // Buscamos los identificadores de aplicación (AI) y los datos correspondientes
    const gtin_match = barcode.match(/(?<=01)[0-9]{14}/);
    if (gtin_match) {
        this.contentParams[index].gtin = gtin_match[0];
        barcode = barcode.slice(gtin_match[0].length);
    }

    const fecha_match = barcode.match(/(?<=17)[0-9]{6}/);
    if (fecha_match) {
        this.contentParams[index].fecha = fecha_match[0];
        barcode = barcode.slice(fecha_match[0].length);
    }

    const lote_match = barcode.match(/(?<=10)[A-Za-z0-9]{1,20}(?=[^0-9A-Za-z]|$)/);
    if (lote_match) {
        this.contentParams[index].lote = lote_match[0];
    }
    // if(this.contentParams.length==index+1){
    //     await this.addNewContentRow();
    //     await this.focusInput(index+1)
    // }
    this.contentParams[index].barcode=""
    // await this.focusInput(index+1)
  }
  }
};
</script>

